<template>
  <div class="retrieve pr" :style="`background-image: url(${$store.state.user.backgroundImage});`">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      class="retrieve-form"
    >
      <h3 class="title fweight500 fsize24">忘记密码</h3>
      <el-form-item prop="phonenumber">
        <el-input
          v-model="form.phonenumber"
          type="text"
          auto-complete="off"
          placeholder="请输入手机号码"
          maxlength="11"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="smsCode">
        <el-input
          v-model="form.smsCode"
          auto-complete="off"
          placeholder="请输入短信验证码"
          style="width: 188px"
          @keyup.enter.native="handleSubmit"
        >
        </el-input>
        <el-button v-if="!countDown" plain class="getCode" @click="handleCapctchaCheck">发送验证码</el-button>
        <span v-else style="margin-left: 14px; color: #565656">{{ countDown }} 秒后重新发送</span>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          type="password"
          auto-complete="off"
          placeholder="请输入新密码（6-16位字母或数字）"
          @keyup.enter.native="handleSubmit"
        >
        </el-input>
      </el-form-item>
       <el-form-item prop="confirmPassword">
        <el-input
          v-model="form.confirmPassword"
          type="password"
          auto-complete="off"
          placeholder="请重复输入新密码"
          @keyup.enter.native="handleSubmit"
        >
        </el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button
          class="marginBom30 retrieveBtn"
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleSubmit"
        >
          <span v-if="!loading">重 置 密 码</span>
          <span v-else>重 置 中...</span>
        </el-button>
        <div class="flex-xCenter">
          返回<router-link
            class="link-type fcolor_darkBlue"
            :to="'/login'"
            >登录</router-link
          >
        </div>
      </el-form-item>
    </el-form>

    <Verify
        @success="capctchaCheckSuccess"
        :mode="'pop'"
        :captchaType="'blockPuzzle'"
        :imgSize="{ width: '330px', height: '155px' }"
        ref="verify"
    ></Verify>

    <!--  底部  -->
    <!-- <div class="brand-footer">
      <span class="fcolor_gray2">Copyright © 浙江大学医学院附属邵逸夫医院</span>
    </div> -->
  </div>
</template>

<script>
import {retrievePwd, sendSmsCode} from "@/utils/api";
import Verify from "@/components/Verifition/Verify";

export default {
  name: "Retrieve",
  components: { Verify },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.form.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      countDown: 0,
      codeUrl: "",
      form: {
        userName: "",
        idCard: "",
        phonenumber: "",
        code: "",
        uuid: "",
        password: "",
        email: "",
        confirmPassword: "",
      },
      rules: {
        phonenumber: [
          { required: true, trigger: "blur", message: "请输入您的手机号码" },
          {
            min: 11,
            max: 11,
            message: "手机号码长度必须为11位",
            trigger: "blur",
          },
        ],
        smsCode: [
          { required: true, trigger: "blur", message: "请输入短信验证码" },
          {
            min: 6,
            max: 6,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的登录密码" },
          {
            min: 6,
            max: 16,
            message: "新密码长度必须介于 6 和 16 之间",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请重复输入新密码" },
          { required: true, validator: equalToPassword, trigger: "blur" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      captchaEnabled: true,
    };
  },
  created() {
  },
  methods: {
    // 提交
    handleSubmit(e) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          retrievePwd(this.form).then((res) => {
            this.$alert('您的密码重置成功，请牢记您的新密码！', '重置成功', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push("/login");
              }
            })
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    // 验证
    handleCapctchaCheck() {
      this.$refs.form.validateField(['phonenumber'], valid => {
        if (!valid) {
          // 验证通过
          this.$refs.verify.show();
        }
      })
    },
    capctchaCheckSuccess(params) {
      sendSmsCode({
        phonenumber: this.form.phonenumber,
        code: params.captchaVerification
      }).then(res => {
        this.countDown = 60
        let that = this

        let interval = setInterval(() => {
          that.countDown = this.countDown - 1
          if (that.countDown <= 0) {
            clearInterval(interval)
          }
        }, 1000);

        this.$message.success(res.msg);
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-form-item__error {
  position: static !important;
}
.retrieve {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-size: cover;
}
.title {
  margin: 0px auto 48px auto;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
}
.flex-xCenter {
  line-height: 19px;
}
.retrieve-form {
  box-sizing: border-box;
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  position: absolute;
  right: 235px;
  top: 108px;
  padding: 30px 40px;
  .el-input {
    height: 40px;
    input {
      padding-left: 11px;
      height: 40px;
    }
  }
  .getCode {
    width: 126px;
    margin-left: 6px;
    border-radius: 3px;
    background-color: #fff;
    color: #253d88;
  }
  .retrieveBtn {
    height: 48px;
  }
  .input-icon {
    height: 40px;
    width: 14px;
    margin-left: 2px;
  }
  & > .el-form-item:not(:nth-child(9)) {
    margin-bottom: 8px;
  }
  & > .el-form-item:nth-child(9) {
    margin-bottom: 30px;
  }
}
.retrieve-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.retrieve-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.retrieve-code-img {
  height: 38px;
}
</style>
